import { ChartSection } from '@/features/domains/Consents/containers'
import { useDashboardStats } from '@/features/domains/Consents/queries'
import { FilterPeriod } from '@/features/domains/Consents/types'

export type Project = {
  id: number
  url: string
}

type Props = {
  project: Project
  filterPeriod: FilterPeriod
  customPeriod: string
}

export function AdminProjectChart({
  project,
  filterPeriod,
  customPeriod,
}: Props) {
  const { data: stats, isLoading } = useDashboardStats({
    enabled: true,
    date_range: filterPeriod,
    custom_date_range: customPeriod,
    project_id: project.id.toString(),
  })

  return (
    <ChartSection
      filterPeriod={filterPeriod}
      customPeriod={customPeriod}
      stats={stats}
      isLoading={isLoading}
      isAdmin
    />
  )
}
